import { AppBar, CardContent, Input, Paper, Slide, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React from "react";
import Countdown from "../../../../Components/Countdown/Countdown";
import Factory from "../../Formatadores/Factory";
import Mensagem from "./Mensagem";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    painel: {
        position: "absolute",
        right: 110,
        bottom: 45,
        zIndex: 99,
        width: _.isNull(md.mobile()) && _.isNull(md.tablet()) ? 460 : 360,
        height: 500,
        backgroundColor: theme.palette.background.default,
        "@media (max-width: 600px)": {
            right: 5,
        }
    },
    toolbar: {
        backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)"
    },
    bgPaper: {
        background: theme.palette.background.paper
    },
});

class Chat extends XAPPComponent {

    state = {
        openPainel: null,
        filtro: "",
        assunto: ""
    };

    componentDidMount() {
        this.listMensagem();
    }

    componentDidUpdate(prevProps, prevState) {
        const { Comunicador } = this.props;
        if (Comunicador.error) {
            this.props.showMessage({
                message: Comunicador.error,
                variant: "error"
            });
            Comunicador.error = null;
        }
        if (Comunicador.warning) {
            this.props.showMessage({
                message: Comunicador.warning,
                variant: "warning"
            });
            Comunicador.warning = null;
        }
        if (Comunicador.info) {
            Comunicador.info = null;
        }
    }

    openPainel = (_AValue = null) => {
        const { open = null } = this.props.Comunicador;
        this.setState(_.set({ ...this.state, "openPainel": _AValue }));
        if (_AValue === null) {
            this.setOpenMessage();
        }
    };

    listMensagem = () => {
        const { xappRouteParams } = this.props;
        this.props.list("SELECIONAR", xappRouteParams, this.getFiltro());
    };

    getLocais = () => {
        let AResponse = [];
        const { Comunicador = null } = this.props;
        if (!_.isNull(Comunicador) && !_.isNull(Comunicador.data)) {
            Comunicador.data.forEach(item => {
                if (_.findIndex(AResponse, { "slug": item.slug }) === -1) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    getMensagens = (_ALocal) => {
        let AResponse = [];
        const { Comunicador = null, xappRouteParams } = this.props;
        if (!_.isNull(Comunicador) && !_.isNull(Comunicador.data)) {
            Comunicador.data.forEach(item => {
                if (_ALocal === item.slug) {
                    AResponse.push(item);
                }
            });
        }
        return _.orderBy(AResponse, "lido", "asc");
    };

    getFiltro = () => {
        const { local = null, Comunicador } = this.props;
        const { open = null } = Comunicador;
        let AFiltros = {
            "procedure": "spvwmensagemchat",
            "OR": [],
            "AND": []
        };
        if (!_.isNull(open)) {
            AFiltros.AND.push({ "Campo": "mensagem.idmensagem", "Operador": "=", "Valor": open.idmensagem });
        }
        if (!_.isNull(local)) {
            AFiltros.AND.push({ "Campo": "local.slug", "Operador": "=", "Valor": local });
        }
        return AFiltros;
    };

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    };

    save = (_AValue, _AAction) => {
        const { save, xappRouteParams } = this.props;
        save(_AValue, xappRouteParams, _AAction, this.getFiltro());
    };

    saveNovaMensagem = () => {
        const { assunto } = this.state;
        const { settings, user, local, xappRouteParams } = this.props;
        let AObj = {
            "idmensagem": null,
            "idpessoaformulario": null,
            "remetente": user.nome,
            "formatador": 1, //chat
            "tipo": 2, //chat
            "confirmacao": 1,
            "interacao": 1,
            "assunto": assunto,
            "conteudos": [],
            "locais": [{
                "slug": local,
                "localnome": settings.sistemas[xappRouteParams.idremetente].nome
            }]
        };

        this.save(AObj, "INSERIR");
        this.handleChange({ target: { "name": "assunto", "value": "" } });
    };

    updateDataLeitura = (_AValue, _AData = null) => {
        if (_.isNull(_AData)) {
            _AData = new Date().toISOString();
        }
        this.save({ "idmensagem": _AValue.idmensagem, "idmensagemlocal": _AValue.idmensagemlocal, "dataleitura": _AData }, "UPDATEDATALEITURA");
    };

    getMensagensPendentes = (_ALocal) => {
        let AResponse = this.getMensagens(_ALocal);
        return _.filter(AResponse, { lido: 0 });
    };

    setOpenMessage = (_AValue = null) => {
        const { Comunicador, setOpenMessage } = this.props;
        const { open = null } = Comunicador;
        if (_AValue === null && !_.isNull(open) && open.status === 2) {
            this.save({ "idmensagem": open.idmensagem }, "FINALIZARMENSAGEMATENDIMENTO");
        }
        setOpenMessage(_AValue);
    };

    render() {
        const { classes, theme, local = null, Comunicador, placeholder = null, get, xappRouteParams } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                {!document.location.pathname.includes("/central-de-notificacoes") &&
                    <React.Fragment>
                        <XAPPButton
                            tooltip={{ "title": "Chat", "placement": "top" }}
                            type="Icon"
                            onClick={() => this.openPainel(form.openPainel ? null : {})}
                            icon={"headset"}
                            badge={this.getMensagensPendentes(local).length}
                        />
                        {_.isNull(Comunicador.open) &&
                            <Countdown
                                time={60 * 2}
                                callback={() => this.listMensagem()}
                                texto="Atualizando em"
                                className="hidden"
                                showButton={true}
                            />
                        }
                        <Paper className={clsx(classes.painel, !form.openPainel && "hidden")}>
                            <AppBar position="static" elevation={1} className="bg-transparent">
                                <Toolbar className="flex w-full min-h-0 p-0">
                                    <Typography variant="subtitle1" className="px-12" color="textSecondary">
                                        {"Mensagens"}
                                    </Typography>
                                    <div className="flex-1" />
                                    {!_.isNull(Comunicador.open) && Comunicador.open.tipo === 2 && Comunicador.open.status === 0 &&
                                        <Countdown
                                            time={15}
                                            callback={() => this.listMensagem()}
                                            texto="Atualizando em"
                                            className="text-11"
                                            showButton={true}
                                        />
                                    }
                                    <XAPPButton
                                        tooltip={{ "title": "Fechar", "placement": "top" }}
                                        type="Icon"
                                        onClick={() => this.openPainel(null)}
                                        icon={"close"}
                                    />
                                </Toolbar>
                            </AppBar>
                            <CardContent className="p-0">
                                <div className={clsx(classes.toolbar, "flex border-b-1 mb-1 p-4")}>
                                    {(!_.isNull(Comunicador.open)) &&
                                        <XAPPButton
                                            tooltip={{ "title": "Voltar", "placement": "top" }}
                                            type="Icon"
                                            className="p-6"
                                            onClick={() => this.setOpenMessage()}
                                            icon={"arrow_back"}
                                        />
                                    }
                                    <Input
                                        placeholder="Filtrar"
                                        className="flex w-full pl-8 py-4 h-32"
                                        disableUnderline
                                        fullWidth
                                        name="filtro"
                                        value={form.filtro}
                                        type='text'
                                        autoComplete="off"
                                        inputProps={{
                                            "aria-label": "Filtar"
                                        }}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                {!_.isNull(local) && _.isNull(Comunicador.open) &&
                                    <div className="p-8 overflow-y-auto" style={{ "height": "55vh" }}>
                                        <Slide
                                            direction="up"
                                            in={true}
                                            timeout={{ enter: 500, exit: 500 }}
                                            className="flex flex-col "
                                        >
                                            <div>
                                                {this.getMensagens(local).map(item => (
                                                    <Mensagem
                                                        data={item}
                                                        theme={theme}
                                                        handleChange={this.handleChange}
                                                        get={get}
                                                        xappRouteParams={xappRouteParams}
                                                        filtro={this.getFiltro()}
                                                        setOpenMessage={this.setOpenMessage}
                                                    />
                                                ))}
                                            </div>
                                        </Slide>
                                    </div>
                                }
                                {!_.isNull(local) && !_.isNull(Comunicador.open) &&
                                    <div className="p-8">
                                        <Slide
                                            direction="up"
                                            in={true}
                                            timeout={{ enter: 500, exit: 500 }}
                                            className="flex flex-col h-400"
                                        >
                                            <div>
                                                <Factory
                                                    {...this.props}
                                                    data={Comunicador.open}
                                                    save={this.save}
                                                    updateDataLeitura={this.updateDataLeitura}
                                                />
                                            </div>
                                        </Slide>
                                    </div>
                                }
                                {!_.isNull(local) && _.isNull(Comunicador.open) &&
                                    <div className={clsx("absolute pin-b pin-r pin-l p-8")}>
                                        <Paper className="flex items-center relative rounded-10" elevation={1}>
                                            <TextField
                                                autoFocus={true}
                                                id="assunto"
                                                name="assunto"
                                                className="flex-1"
                                                InputProps={{
                                                    disableUnderline: true,
                                                    classes: {
                                                        root: "flex flex-grow flex-no-shrink ml-16 mr-48 my-8",
                                                        input: ""
                                                    },
                                                    placeholder: !_.isNull(placeholder) ? placeholder : "Nova mensagem"
                                                }}
                                                InputLabelProps={{ shrink: false }}
                                                onChange={this.handleChange}
                                                value={form.assunto}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === "Enter") {
                                                        this.saveNovaMensagem();
                                                    }
                                                }}
                                            />
                                            <XAPPButton
                                                type="Icon"
                                                className="absolute pin-r pin-t"
                                                onClick={() => this.saveNovaMensagem()}
                                                icon={"send"}
                                            />
                                        </Paper>
                                    </div>
                                }
                            </CardContent>
                        </Paper>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Chat);

